/* eslint-disable @next/next/no-img-element */
import { FC, useMemo } from 'react'
import { NewsGreyIcon } from '@/src/assets/icons'
import { useStore } from '@/src/types/store'

interface ContentThumbnailProps {
  item: any
  alt?: string
  className?: string
  fallbackClassName?: string
  fallbackIconClassName?: string
}

const ContentThumbnail: FC<ContentThumbnailProps> = ({
  item,
  alt = '',
  className = '',
  fallbackClassName = 'flex items-center justify-center bg-[#46586B4D]',
  fallbackIconClassName = 'h-24 w-24'
}) => {
  const { companyThumbnails } = useStore()

  // Using memo to avoid recomputing with different random images
  const src = useMemo(() => {
    if (item?.thumbnail && item.thumbnail !== 'N/A') return item.thumbnail

    const len = companyThumbnails?.length || 0
    if (len === 0) return ''

    const index = item?.id ? item.id % len : Math.floor(Math.random() * len)
    return companyThumbnails[index]?.url || ''
  }, [companyThumbnails, item?.thumbnail, item?.id])

  if (src) {
    return <img src={src} alt={alt} className={className} />
  }

  return (
    <div className={fallbackClassName}>
      <NewsGreyIcon className={fallbackIconClassName} />
    </div>
  )
}

export default ContentThumbnail
